// Copyright (c) 2025 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

export enum ToggleSize {
    Small = 'small',
    Default = 'default',
}

export enum ToggleLabelPosition {
    Left = 'left',
    Right = 'right',
}
